<p>konkurs-statistics works!</p>
